import React from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useStudentAuth } from '../context/StudentAuthContext';

/**
 * Protected Route component for student pages
 * Redirects to student login if not authenticated as a student
 */
function StudentProtectedRoute({ children }) {
  const { studentUser, loading } = useStudentAuth();

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="loading-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        color: 'rgba(255, 255, 255, 0.6)'
      }}>
        <div className="loading-spinner" style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255, 255, 255, 0.1)',
          borderTop: '4px solid #0077b6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p>Laden...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If no student user, redirect to student login
  if (!studentUser) {
    return <Navigate to="/student-login" />;
  }

  // Otherwise, render the protected content (met noindex voor crawlers)
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {children}
    </>
  );
}

export default StudentProtectedRoute;
